<template>
  <div class="retreatInfo">
    <topTitle title="退换货详情"></topTitle>
    <div class="topInfo">
      <div><img src="../../assets/temporaryPicture/sp2.png" alt=""></div>
      <p>SDHC9E15-210电磁炉防水智能电…</p>
      <span>已提交</span>
    </div>
    <div class="record mt-20">
      <div class="top">评价记录</div>
      <div class="body">
        <p>商家服务很好！商品非常好！</p>
        <div>
          <div><img src="../../assets/temporaryPicture/sp3.png" alt=""></div>
          <div><img src="../../assets/temporaryPicture/sp3.png" alt=""></div>
          <div><img src="../../assets/temporaryPicture/sp3.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
// import { Swipe, SwipeItem, Tab, Tabs, Dialog} from 'vant';
export default {
  name: "retreatInfo",
  data() {
    return {};
  },
  components: {
    topTitle
  },
  methods: {
    
  }
};
</script>


<style scoped lang='less'>
.retreatInfo {
  .topInfo{
      width: 100%;height: 200px;padding: 29px 35px 35px 35px;
      background: #fff;
      display: flex;
      justify-content: space-between;
      div{
        width: 136px;
        height: 136px;
        margin-right: 40px;
      }
      p{
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        flex: 1;
      }
      span{
        font-size:28px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        display: flex;
        align-items: center;

      }
    }
  .record{
    background: #ffffff;
    .top{
      height: 68px;
      line-height: 68px;
      padding: 0 35px;
      font-size:22px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      border-bottom: 1px solid #F5F5F5;
    }
    .body{
      padding: 35px;
      p{
        color: #000000;
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
      }
      >div{
        margin-top: 20px;
        overflow: hidden;
        >div{
          width: 146px;
          height: 146px;
          float: left;
          margin-right: 20px;
        }
      }
    }
  }



}
</style>


